import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/cpa-firm/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/cpa-firm/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "cpa-firm" entry).

export const cpaFirm: ContentPage = {
  slug: "solutions/cpa-firm",
  template: "solution",
  seo: {
    title: "CPA Firm Solutions for Efficient Practice Management",
    description: "GetBiz Solutions offers tailored software solutions for CPA firms, focusing on audit preparation, client management, and financial reporting.",
    keywords: [
      "CPA firm software",
      "client management",
      "audit preparation",
      "financial reporting",
      "CPA firm tools",
      "accounting software",
      "practice management",
      "compliance tracking",
    ],
    ogImage: "/assets/data/seoimages/cpa-firm.webp",
  },
  solution: {
    hero: {
      title: "Optimize Your CPA Firm’s Processes with Automation",
      description: "Improve your CPA firm’s operations with automated solutions for better workflow and client service.",
      image: "/assets/images/img/cpa_firm_solution.webp",
      imageAlt: "cpa_firm_solution",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Book A Demo", href: "/book-demo/" },
    },
    servicesTitle: "Enhance Efficiency in Every Aspect of Your Operations",
    services: [
      { title: "Billing and Time Tracking Automation", description: "Automate the billing process and track time spent on client projects for accurate and timely invoicing." },
      { title: "Client Management System", description: "Keep track of client accounts, communications, and follow-ups with automated client management features." },
      { title: "Employee Payroll Automation", description: "Automate payroll processes, ensuring timely salary disbursements and compliance with tax laws." },
      { title: "Document Filing and Storage", description: "Securely manage client financial records and documents, ensuring they are easy to access and track." },
      { title: "Task and Project Automation", description: "Assign and monitor tasks within your team, ensuring efficient project management and deadline tracking." },
      { title: "Compliance Management", description: "Keep your firm and clients compliant with regulations by automating reminders for tax filings, audits, and reports." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Discover how GetBiz Solutions supports CPA firms with powerful tools. Our FAQs detail solutions for client management, financial tracking, and audit preparation. Learn how our platform simplifies processes, improves reporting accuracy, and ensures compliance, enabling your CPA firm to work smarter and deliver better results for clients.",
    metaKey: "cpa-firm",
  },
  sections: [],
};
